export default "__VITE_ASSET__CFL965GF__ 400w, __VITE_ASSET__B_T035Zd__ 800w, __VITE_ASSET__us2ByW$n__ 1200w";